module.exports = __webpack_public_path__ + "static/media/AUGraph.9edfae9f.svg";


//////////////////
// WEBPACK FOOTER
// ./src/AUGraph.svg
// module id = 2031
// module chunks = 0